import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageDialogData } from 'src/app/_config/message-dialog-data';
import { IconService } from 'src/app/_core/services/icon.service';

@Component({
  selector: 'app-anagrafica-message-dialog',
  templateUrl: './anagrafica-message-dialog.component.html',
  styleUrls: ['./anagrafica-message-dialog.component.scss']
})
export class AnagraficaMessageDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogData,
    public dialogRef: MatDialogRef<AnagraficaMessageDialogComponent, boolean>,
  ) {
  }
}
